// @flow
import React from 'react';
import moment from 'moment';

type Props = {
  data: Object,
};

export default function FlightPurchaseItem(props: Props) {
  const { status, amount, currency = 'USD', item_data } = props.data;
  const { flight_details, return_flight_details } = item_data;
  const { arrival, departure, flight_date } = flight_details;

  const format = date => moment(date, 'D MMM YYYY').format('D MMM YYYY');

  return (
    <div className="list-row">
      <div className="item date">
        {format(flight_date)}{' '}
        {return_flight_details && `- ${format(return_flight_details.flight_date)}`}
      </div>
      <div className="item name">
        <i className="icon icon-hg-flight" /> {`${departure} - ${arrival}`}
        {return_flight_details && `- ${return_flight_details.arrival}`}
      </div>
      <div className="item price">
        {currency} {amount}
      </div>

      {status === 'failed' ? (
        <div className="item message error">Bookings rejected</div>
      ) : (
        <div className="item message error" />
      )}

      <div className="item cta">
        <div color="outline" size="sm" className={status === 'Pending' ? 'pending' : ''}>
          {status ? status : ''}
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Profile/PurchaseList/FlightPurchaseItem.jsx